export default __webpack_public_path__ + "static/media/error_image.f8cc4336.svg";